// extracted by mini-css-extract-plugin
export default {"summaryColumn":"style_summaryColumn__uBiTP","columnText":"style_columnText__cZLcF"};